import React from 'react';

const landingWrapper = {
  paddingTop: '25px',
};

const logoStyle = {
  position: 'relative',
  top: 0,
  left: 0,
  width: '200px',
  height: '150px',
};

const headerStyle = {
  marginTop: '30px',
};

const containLogoDivStyle = {
  width: '200px',
};

const LandingLeonards = (props) => {
  const { history, setActiveComponent } = props;

  return (
    <div className="gb-landing" style={landingWrapper}>
      <div className="gb-landing__top clearfix">
        <div className="gb-landing__top__left">
          <div style={containLogoDivStyle}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 75 32"
              className="aspect-auto h-10 sm:h-12"
            >
              <desc>Leonard's Studio</desc>
              <desc>Estudio de Leonard</desc>
              <path
                fill="var(--leonard-green)"
                d="m22.324 19.309-.768.87c-.46.597-1.006 1.33-1.603 2.286-1.603 2.541.085 4.128 2.269 3.394.972-.29 3.019-1.791 3.991-2.44.478-.323.478.12.495.07.102-.274 1.382-2.679 1.382-2.679-4.333 3.377-6.141 4.077-6.141 4.077-.938.46-1.263.017-1.109-.529.41-1.399 1.552-2.627 1.893-3.087.307-.41.973-1.194.973-1.194s-.768-.103-1.399-.751z"
              ></path>
              <path
                fill="var(--leonard-green)"
                d="M23.689 20.111c.563.188 1.143 0 1.262 0 1.467-.358 1.91-1.33 1.91-1.723.018-.136-.153-.29-.323-.273-1.11-.034-2.286 1.28-2.661 1.723-.051.068-.086.12-.12.154l-.05.085c-1.127-.222-1.4-.75-1.4-.75s.034-.052.12-.154a9.3 9.3 0 0 1 1.091-1.194c1.075-1.024 2.747-2.115 4.316-1.382 0 0 1.552.99.239 2.712-.853 1.194-2.576 2.286-5.118 1.894m0-.017.734-1.075c-1.126-.222-1.399-.75-1.399-.75-.324-.393-.12-.956.17-1.365.257-.358.547-.614.547-.614l-.256-.529s-.341.205-.46.324c-.12.102-.734.512-.973 1.33-.205.87.17 1.604.17 1.604s.29.733 1.467 1.092M26.81 23.13c-.512 1.433-.085 3.087 1.433 3.087 4.4 0 7.283-6.14 7.283-6.14 1.45-2.508-.34-3.514-.34-3.514s-1.229-1.007-4.01 1.143c-3.65 2.814-4.366 5.424-4.366 5.424m8.051-4.384c.085 1.007-4.571 7.01-6.362 6.056 0 0-.376-.444.204-1.484.478-.87 2.388-3.992 5.032-4.981 0 0 1.04-.563 1.126.41"
              ></path>
              <path
                fill="var(--leonard-green)"
                d="M41.412 22.891c-1.143 1.825-1.825 2.371-1.825 2.371-.682.29.034-1.399.955-3.173a95 95 0 0 1 2.098-3.787c.46-.119.392-.443.273-.699-.085-.17-.324-.46-.324-.46-.341-.393-.802-.052-1.347.494-.632.648-1.212 1.552-1.212 1.552-1.125 1.212-1.33.666-1.33.666.205-1.109-.154-1.28-.154-1.28-.699-.818-2.166 1.518-2.166 1.518-.443.29-.768.427-.921.427-.853.12-.955-.29-.955-.29-.359-.87-.069-1.825-.034-1.945.119-.443.682-2.32.682-2.32l-.358-.085s-.99 1.842-1.246 2.61c-.255.734-.409 1.57-.119 2.303 0 0 .273.819.785.99.426.17.836-.29.836-.29 1.108-.888 1.313-.274 1.262.033-.273 1.11-1.791 3.054-1.791 3.054l1.04.665c.444-.307 1.638-1.945 2.457-3.105l.92-1.313c.052-.068.086-.085.137-.12.393-.306.768-.136.665.256a.4.4 0 0 1-.05.154c-.376.58-1.314 2.712-1.314 2.712-.955 2.286.29 2.73.29 2.73.853.528 2.2-1.621 2.2-1.621l.529-2.047z"
              ></path>
              <path
                fill="var(--leonard-green)"
                d="M55.876 22.533c-.819-.307-1.518.836-1.518.836-.87 1.484-1.262.665-1.262.665-.103-.46.511-1.467 1.21-2.44a38 38 0 0 1 1.775-2.217c.136-.563-1.348-1.262-1.348-1.262l.137-.273.204-.972h-1.126s-.017.256-.068.716-1.961 2.49-3.428 4.094c-1.058 1.143-1.962 2.064-1.962 2.064-.256.222-.426.392-.597.478-.58.204-.495-.648-.341-.819.392-.46 3.53-4.18 3.53-4.18.206-.374-.067-.647-.067-.647l-1.757.034c-.887 1.28-1.928 2.32-2.798 3.156-1.33 1.296-2.848 2.405-3.002 2.541-.75.512-.58-.068-.495-.256.41-.836.922-1.586 1.433-2.251 2.388-3.07 5.203-4.316 5.203-4.316 1.04-.478.63.341.63.341.206.358.598 0 .598 0a.97.97 0 0 0 .392-.597c.273-1.62-1.484-1.313-1.484-1.313-.92.136-1.944.665-2.95 1.398-1.672 1.211-3.395 2.832-4.64 4.538-.307.426-1.467 1.74-1.28 2.985.103.443.256.682.427.819.239.204.836.204 1.04.136 1.467-.444 3.531-2.354 3.531-2.354.802-.768.768-.29.768-.29-1.024 2.866.92 2.559.92 2.559.547-.069 2.645-2.354 4.265-4.077.99-1.024 1.74-1.86 1.74-1.86l.427.274c-.103.085-.53.835-1.04 1.569-.632.887-1.127 1.791-1.127 1.791-.102.153-.136.392-.153.443-.154 1.587 1.518 1.416 1.518 1.416 1.33-.256 2.15-1.859 2.15-1.859.29-.46.374-.188.374-.188l.154-.716z"
              ></path>
              <path
                fill="var(--leonard-green)"
                d="M55.706 23.437c.051 2.064 1.808 1.586 1.808 1.586 2.081-.221 4.81-3.735 4.81-3.735.052-.051.154-.17.205-.205.341-.205.478-.068.46.188 0 .136-.05.239-.068.239-1.603 3.735.546 3.599.546 3.599.768 0 .495-.563.495-.563-.341-.034-.392-.478-.341-.938.05-.495.307-1.706.443-2.133.427-1.262 1.348-2.865 2.422-4.486 2.559-3.872 6.022-7.897 6.022-7.897-.24-.717-.99-1.075-.99-1.075-1.467.768-6.345 8.785-6.345 8.785a5 5 0 0 1-.188.238c-.784.939-3.07 3.054-4.708 4.538-1.04.938-1.808 1.62-1.808 1.62-.221.188-.41.307-.563.392-.852.495-.528-.58-.511-.682.068-.358.307-.836.614-1.28 1.074-1.586 3.394-3.394 4.998-4.536 1.006-.717 1.74-1.194 1.74-1.194.204-.649-.717-1.365-.717-1.365-1.603.7-2.831 1.535-4.196 2.627-2.9 2.286-3.89 5.134-3.89 5.134s-.255.802-.238 1.16zM73.258 10.183l-2.166 3.087c-.069.376.358.427.358.427.375 0 2.934-2.525 2.934-2.525zM72.473 16.017l-7.505 7.864.426.648s.444-.222.631-.41 4.503-4.64 4.742-4.742c.188-.085.512-.085.086.99 0 0-1.092 2.933-2.15 3.735 0 0-.801.631-1.484.103 0 0 .069 1.518 1.553 1.518a1 1 0 0 0 .375-.069s2.37-.887 3.991-8.648l-.682-.989zM19.339 0l-1.143 1.484s.682 1.842.597 2.337c0 0-.222 1.092-.63 1.757 0 0-1.673 3.275-4.3 7.232-2.916 4.384-6.959 9.672-10.165 13.305C1.685 28.401.405 29.612.064 29.612c0 0-.477 1.518 1.177 2.388 0 0 6.21-5.902 16.478-8.051 0 0-.34-1.91-.904-2.73 0 0-.273.632-1.109 1.28L3.87 28.401S19.459 8.904 20.892 4.333c0 0 .614-.7-1.519-4.298z"
              ></path>
            </svg>
          </div>
          <h1 className="gb-landing__top__left__header" style={headerStyle}>
            Welcome
          </h1>
          <h3 className="gb-landing__top__left__subheader">
            To Leonards online ordering!
          </h3>
          <h3 className="gb-landing__top__left__subheader">
            For the security of your child, you must create an account to place
            an order.
          </h3>
          <div
            className="gb-landing__signup-button cursor-pointer"
            onClick={() => history.push('/account-lookup', { step: 1 })}
            // onClick={() => console.log('🫠🫠🫠')}
          >
            Place Your Order
          </div>
        </div>
        <img
          className="gb-landing__top__image"
          src="https://s3.amazonaws.com/pics-assets/landing/gb_main.png"
          alt=""
        />
      </div>
    </div>
  );
};

export default LandingLeonards;
